define("shared/components/shared/ui/social-set-switcher/social-set", ["exports", "@ember/component", "@ember/service", "@ember/utils", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _utils, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="tPA--setWrapper">
    {{#if (and @shouldHaveLabel (or (not @isMobile) @showAllProfilesOnMobile))}}
      <span class={{concat "tPA--set__label" (if @isSelected " u--text--hl")}}>
        {{t "shared_phrases.social_set"}}
        {{@index}}
        {{#if (and this.canAccessOCE this.isCreatorProfile)}}
          <div class="cSS--set__label u--text--sm">
            {{t "account.creator_profile.title"}}
            <span>{{svg-jar "info" class="o--icon--sm cSS--set__labelIcon"}}</span>
          </div>
        {{/if}}
      </span>
    {{/if}}
  
    <div
      class={{concat
        (if @isFocused "u--block" "tPA--set")
        (if @isMobile " u--flex")
        (if (and @isSelected (or (not @isMobile) @showAllProfilesOnMobile)) " is--active")
      }}
    >
      {{#each this.profiles as |socialProfile|}}
        {{#if socialProfile.hasProfile}}
          <Shared::SocialIdentity::Item
            @customClass={{this.disableHoverClass}}
            @socialProfile={{socialProfile.profile}}
          />
        {{else}}
          <Shared::SocialIdentity::PlaceholderItem @platform={{socialProfile.profileType}} />
        {{/if}}
      {{/each}}
  
      {{#if (and @isMobile this.canAccessOCE)}}
        <div>
          <p class="u--text--bold u--m__b__0">{{t "shared_phrases.social_set"}} {{if (is-present @index) @index}}</p>
          <p class="u--m__b__0">
            {{@socialIdentity.socialProfiles.length}}
            {{t "shared_words.social_profiles"}}
          </p>
        </div>
      {{/if}}
  
      {{#if (has-block)}}
        {{yield}}
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "nhU/P3qk",
    "block": "[[[10,0],[14,0,\"tPA--setWrapper\"],[12],[1,\"\\n\"],[41,[28,[37,1],[[30,1],[28,[37,2],[[28,[37,3],[[30,2]],null],[30,3]],null]],null],[[[1,\"    \"],[10,1],[15,0,[28,[37,4],[\"tPA--set__label\",[52,[30,4],\" u--text--hl\"]],null]],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"shared_phrases.social_set\"],null]],[1,\"\\n      \"],[1,[30,5]],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"canAccessOCE\"]],[30,0,[\"isCreatorProfile\"]]],null],[[[1,\"        \"],[10,0],[14,0,\"cSS--set__label u--text--sm\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"account.creator_profile.title\"],null]],[1,\"\\n          \"],[10,1],[12],[1,[28,[35,6],[\"info\"],[[\"class\"],[\"o--icon--sm cSS--set__labelIcon\"]]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[15,0,[28,[37,4],[[52,[30,6],\"u--block\",\"tPA--set\"],[52,[30,2],\" u--flex\"],[52,[28,[37,1],[[30,4],[28,[37,2],[[28,[37,3],[[30,2]],null],[30,3]],null]],null],\" is--active\"]],null]],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"profiles\"]]],null]],null],null,[[[41,[30,7,[\"hasProfile\"]],[[[1,\"        \"],[8,[39,9],null,[[\"@customClass\",\"@socialProfile\"],[[30,0,[\"disableHoverClass\"]],[30,7,[\"profile\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,10],null,[[\"@platform\"],[[30,7,[\"profileType\"]]]],null],[1,\"\\n\"]],[]]]],[7]],null],[1,\"\\n\"],[41,[28,[37,1],[[30,2],[30,0,[\"canAccessOCE\"]]],null],[[[1,\"      \"],[10,0],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold u--m__b__0\"],[12],[1,[28,[35,5],[\"shared_phrases.social_set\"],null]],[1,\" \"],[1,[52,[28,[37,11],[[30,5]],null],[30,5]]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n          \"],[1,[30,8,[\"socialProfiles\",\"length\"]]],[1,\"\\n          \"],[1,[28,[35,5],[\"shared_words.social_profiles\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[48,[30,9]],[[[1,\"      \"],[18,9,null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@shouldHaveLabel\",\"@isMobile\",\"@showAllProfilesOnMobile\",\"@isSelected\",\"@index\",\"@isFocused\",\"socialProfile\",\"@socialIdentity\",\"&default\"],false,[\"if\",\"and\",\"or\",\"not\",\"concat\",\"t\",\"svg-jar\",\"each\",\"-track-array\",\"shared/social-identity/item\",\"shared/social-identity/placeholder-item\",\"is-present\",\"has-block\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/social-set-switcher/social-set.hbs",
    "isStrictMode": false
  });
  let SocialSetComponent = _exports.default = (_class = class SocialSetComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
    }
    get socialIdentity() {
      return this.args.socialIdentity;
    }
    get socialProfiles() {
      return this.socialIdentity.socialProfiles;
    }
    get disableHoverClass() {
      const isDropdownOpen = !!document.getElementsByClassName('qa--profileSwitcher_dropdown')?.length;
      return this.args.disableHover && isDropdownOpen ? 'tooltip-hidden' : '';
    }
    get instagramProfile() {
      return this.socialProfiles.filterBy('isInstagram').objectAt(0);
    }
    get hasInstagramProfile() {
      return !(0, _utils.isEmpty)(this.instagramProfile);
    }
    get facebookProfile() {
      return this.socialProfiles.filterBy('isFacebook').objectAt(0);
    }
    get hasFacebookProfile() {
      return !(0, _utils.isEmpty)(this.facebookProfile);
    }
    get twitterProfile() {
      return this.socialProfiles.filterBy('isTwitter').objectAt(0);
    }
    get hasTwitterProfile() {
      return !(0, _utils.isEmpty)(this.twitterProfile);
    }
    get pinterestProfile() {
      return this.socialProfiles.filterBy('isPinterest').objectAt(0);
    }
    get hasPinterestProfile() {
      return !(0, _utils.isEmpty)(this.pinterestProfile);
    }
    get tiktokProfile() {
      return this.socialProfiles.filterBy('isTiktok').objectAt(0);
    }
    get hasTiktokProfile() {
      return !(0, _utils.isEmpty)(this.tiktokProfile);
    }
    get linkedinProfile() {
      return this.socialProfiles.filterBy('isLinkedin').objectAt(0);
    }
    get hasLinkedinProfile() {
      return !(0, _utils.isEmpty)(this.linkedinProfile);
    }
    get youtubeProfile() {
      return this.socialProfiles.filterBy('isYoutube').objectAt(0);
    }
    get hasYoutubeProfile() {
      return !(0, _utils.isEmpty)(this.youtubeProfile);
    }
    get isCreatorProfile() {
      return (0, _utils.isPresent)(this.socialIdentity.influencerId);
    }
    get profiles() {
      const profiles = [{
        profileType: 'ig',
        hasProfile: this.hasInstagramProfile,
        profile: this.instagramProfile
      }, {
        profileType: 'fb',
        hasProfile: this.hasFacebookProfile,
        profile: this.facebookProfile
      }, {
        profileType: 'pin',
        hasProfile: this.hasPinterestProfile,
        profile: this.pinterestProfile
      }, {
        profileType: 'tk',
        hasProfile: this.hasTiktokProfile,
        profile: this.tiktokProfile
      }, {
        profileType: 'li',
        hasProfile: this.hasLinkedinProfile,
        profile: this.linkedinProfile
      }];
      if (this.auth.currentAccount.rolloutYoutubeCampaigns) {
        profiles.push({
          profileType: 'yt',
          hasProfile: this.hasYoutubeProfile,
          profile: this.youtubeProfile
        });
      }
      if (this.args.hideTwitterIdentities !== true && this.hasTwitterProfile) {
        profiles.push({
          profileType: 'tw',
          hasProfile: this.hasTwitterProfile,
          profile: this.twitterProfile
        });
      }
      if (this.args.isMobile && !this.args.showAllProfilesOnMobile) {
        const firstProfile = profiles.find(social => social.hasProfile) ?? profiles[0];
        return [firstProfile];
      }
      return profiles;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialSetComponent);
});